module.exports = __webpack_public_path__ + "static/media/pizza.a9ef106e.svg";